// src/pages/Admin/Adherents/components/AdherentFiltersBar.jsx

import React from "react";
import { FaFilter, FaSearch, FaTimes } from "react-icons/fa";
import { STATUS_OPTIONS } from "../helpers";

export default function AdherentFiltersBar({
  searchTerm,
  setSearchTerm,
  seasonFilter,
  setSeasonFilter,
  seasons = [],
  statusFilter,
  setStatusFilter,
  communeFilter,
  setCommuneFilter,
  communes = [],
  dojos = [],
  selectedDojo,
  handleDojoChange,
  groups = [],
  groupFilter,
  setGroupFilter,
  genreFilter,
  setGenreFilter,
  filteredCount,
  resetFilters,
}) {
  return (
    <div className="border-b border-slate-200 p-4 dark:border-slate-800 sm:p-5 lg:p-6">
      <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
        <div>
          <h2 className="text-xl font-bold text-slate-900 dark:text-white">
            Tableau des adhérents
          </h2>

          <p className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-300">
            {Number(filteredCount || 0).toLocaleString("fr-FR")} adhérent
            {filteredCount > 1 ? "s" : ""} affiché
            {filteredCount > 1 ? "s" : ""}
          </p>
        </div>

        <button
          type="button"
          onClick={resetFilters}
          className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
        >
          <FaTimes />
          Réinitialiser
        </button>
      </div>

      <div className="mt-4 grid gap-2 xl:grid-cols-[minmax(260px,1.5fr)_repeat(6,minmax(150px,1fr))]">
        <div className="relative xl:col-span-2">
          <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

          <input
            type="text"
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            placeholder="Rechercher nom, prénom, email, téléphone, licence..."
            className="w-full rounded-2xl border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          />
        </div>

        <select
          value={seasonFilter}
          onChange={(event) => setSeasonFilter(event.target.value)}
          className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          <option value="">Toutes saisons</option>
          {seasons.map((season) => (
            <option key={season} value={season}>
              {season}
            </option>
          ))}
        </select>

        <select
          value={statusFilter}
          onChange={(event) => setStatusFilter(event.target.value)}
          className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          <option value="">Tous statuts</option>
          {STATUS_OPTIONS.map((status) => (
            <option key={status} value={status}>
              {status}
            </option>
          ))}
        </select>

        <select
          value={selectedDojo}
          onChange={handleDojoChange}
          className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          <option value="">Tous dojos</option>
          {dojos.map((dojo) => (
            <option key={dojo.id} value={dojo.id}>
              {dojo.dojo_nom || dojo.nom || dojo.name}
            </option>
          ))}
        </select>

        <select
          value={groupFilter}
          onChange={(event) => setGroupFilter(event.target.value)}
          className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          <option value="">Tous groupes</option>
          {groups.map((group) => (
            <option key={group.id} value={group.nom}>
              {group.nom}
            </option>
          ))}
        </select>

        <select
          value={communeFilter}
          onChange={(event) => setCommuneFilter(event.target.value)}
          className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          <option value="">Toutes communes</option>
          {communes.map((commune) => (
            <option key={commune} value={commune}>
              {commune}
            </option>
          ))}
        </select>

        <select
          value={genreFilter}
          onChange={(event) => setGenreFilter(event.target.value)}
          className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          <option value="">Tous genres</option>
          <option value="Masculin">Masculin</option>
          <option value="Féminin">Féminin</option>
        </select>
      </div>

      <div className="mt-4 rounded-2xl border border-indigo-200 bg-indigo-50 px-4 py-3 text-xs leading-5 text-indigo-800 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300">
        <span className="inline-flex items-center gap-2 font-bold">
          <FaFilter />
          Astuce :
        </span>{" "}
        les filtres agissent sur la liste exportée, les emails copiés et le PDF
        global. La colonne “Actions” reste visible même en défilement horizontal.
      </div>
    </div>
  );
}